import apiRequest from "@core/services/api/apiRequest";
import type { MeetingDetails } from "@platform/features/video/types/video.types";

export { MeetingDetails };

export const getMeetingDetails = async (meetingId: string): Promise<MeetingDetails> => {
  return apiRequest(`/api/meeting/${meetingId}/`, "GET");
};
